import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

import { realResultsData } from 'utils/config/realResults';
import { Image, TrustpilotWidget } from 'components';


const SectionRealResults = ({ title, className }) => {
  const [width, setWidth] = useState(0);
  const settingsCarousel = {
    centered: true,
    dots: true,
    infinite: true,
    slidesPerPage: 1,
  };

  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  });

  const ltDesktop = () => (
    <Carousel {...settingsCarousel}>
      {realResultsData.map(({ image, author, text }, idx) => (
        <div className='real-results-wrapper' key={idx}>
          <div className='testimonials-wrapper'>
            <div className='rr-testimonial'>
              <p><b>{author}</b></p>
              <p>"{text}"</p>
            </div>
          </div>
          <div className='fake-gif-wrapper'>
            <Image {...image} />
          </div>
        </div>
      ))}
    </Carousel>
  );

  const gteDesktop = () => (
    <div className='real-results-wrapper'>
      {realResultsData.map((rrD, idx) => {
        if (idx % 2) return false;

        return (
          <div className='real-results-col' key={idx}>
            <div className='testimonials-wrapper'>
              <div className='rr-testimonial'>
                <p><b>{rrD.author}</b></p>
                <p>"{rrD.text}"</p>
              </div>
              <div className='rr-testimonial'>
                <p><b>{realResultsData[idx+1].author}</b></p>
                <p>"{realResultsData[idx+1].text}"</p>
              </div>
            </div>
            <div className='fake-gif-wrapper'>
              <Image {...rrD.image} />
              <Image {...realResultsData[idx+1].image} />
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className={cx('section-real-results fvw mt-90 mb-90 t-center', [className])}>
      <div className='content-wrapper'>
        <div className='title-wrapper'>
          <h2>{title}</h2>
          <TrustpilotWidget />
        </div>
        { width < 1000 ? ltDesktop() : gteDesktop() }
      </div>
    </div>
  );
};

SectionRealResults.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

SectionRealResults.defaultProps = {
  title: 'Real results',
  className: '',
};

export default SectionRealResults;
